import React from 'react';
import CompanyApiKeyList from "./components/CompanyApiKeyList";

function CompanyApiKeys(props) {
  return (
    <div>
      <CompanyApiKeyList />
    </div>
  );
}

CompanyApiKeys.propTypes = {};
CompanyApiKeys.defaultProps = {};

export default CompanyApiKeys;
